// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2iQ59","title":"BackImages_title__3V8vz","images":"BackImages_images__30bSC"};